import BigNumber from 'bignumber.js';
import { useMemo, useEffect } from 'react';
import { BestBuyStatus, useUserBestBuyList } from "../../../hooks";
import { useRefreshToken } from "../../../state/application/hooks";
import { FixedPointNumber } from "../../../utils/fixedPoint";
export var useActiveOrdersOccupiedAmount = token => {
  var refreshToken = useRefreshToken();

  var _useUserBestBuyList = useUserBestBuyList([BestBuyStatus.Pending, BestBuyStatus.PartialFilled]),
      _useUserBestBuyList$d = _useUserBestBuyList.data,
      bestBuyOrders = _useUserBestBuyList$d === void 0 ? [] : _useUserBestBuyList$d,
      hasNextPage = _useUserBestBuyList.hasNextPage,
      size = _useUserBestBuyList.size,
      setSize = _useUserBestBuyList.setSize;

  useEffect(() => {
    setSize(1);
  }, [refreshToken]);
  useEffect(() => {
    if (hasNextPage) {
      setSize(size + 1);
    }
  }, [hasNextPage, bestBuyOrders.length, refreshToken]);
  return useMemo(() => {
    var decimals = token === null || token === void 0 ? void 0 : token.decimals;
    var activeOrderBalance = bestBuyOrders.filter(order => order.userToken.toLowerCase() === token.address.toLowerCase()).reduce((acc, order) => {
      return acc.plus((order.status === BestBuyStatus.Pending ? order.userTokenAmount : order.remainQuota) || '0');
    }, new BigNumber(0));
    return new FixedPointNumber(activeOrderBalance, decimals);
  }, [token, bestBuyOrders]);
};